import { STATIC_URL } from 'constants/data'

const ShareType = {
  COPY: 'copy',
  VK: 'vk',
  ODNOKL: 'odnokl',
  FB: 'fb',
  TELEGRAM: 'telegram',
  WHATSAPP: 'whatsapp',
}

const iconPath = {
  copy: `${STATIC_URL}/like-share/icon_link.svg`,
  vk: `${STATIC_URL}/social-network/icon_vk.svg`,
  // facebook: `${STATIC_URL}/social-network/icon_faceb.svg`,
  odonkla: `${STATIC_URL}/social-network/icon_odnokl.svg`,
  telegram: `${STATIC_URL}/social-network/icon_telegr.svg`,
  whatsapp: `${STATIC_URL}/social-network/icon_whatsapp.svg`,
}

const shareItems = [
  {
    type: ShareType.COPY,
    text: 'Копировать ссылку',
    image: iconPath.copy,
    alt: 'скопировать ссылку в буфер.',
  },
  {
    type: ShareType.VK,
    text: 'ВКонтакте',
    image: iconPath.vk,
    alt: 'поделиться во вконтакте.',
  },
  {
    type: ShareType.ODNOKL,
    text: 'Одноклассники',
    image: iconPath.odonkla,
    alt: 'поделиться в одноклассниках.',
  },
  // {
  //   type: ShareType.FB,
  //   text: 'Facebook',
  //   image: iconPath.facebook,
  //   alt: 'поделиться в фейсбуке.',
  // },
  {
    type: ShareType.TELEGRAM,
    text: 'Telegram',
    image: iconPath.telegram,
    alt: 'поделиться в телеграмме.',
  },
  {
    type: ShareType.WHATSAPP,
    text: 'WhatsApp',
    image: iconPath.whatsapp,
    alt: 'поделиться в вотсаппе.',
  },
]

export { iconPath, ShareType, shareItems }
